/**
 * Service for position list operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import { mapPositionsListFromTransport } from '../mappers';
import type {
  LC_GetPositionsListOut,
  PositionsListFilters,
  PositionsListResult,
} from '../types';


export class PositionListService {
  async list(filters?: PositionsListFilters): Promise<ApiResponse<PositionsListResult>> {
    const queryString = buildQueryString(filters ?? {});
    const endpoint = `${API_CONFIG.ENDPOINTS.ORGANIZATION.POSITIONS}${queryString}`;

    const response = await apiClient.get<LC_GetPositionsListOut>(endpoint);

    if (response.success && response.data) {
      return {
        ...response,
        data: mapPositionsListFromTransport(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const positionList = new PositionListService();
